import React, { ButtonHTMLAttributes, ReactNode } from "react";
import { Spinner } from "./Spinner.tsx";

interface ToggleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "submit" | "neutral" | "primary";
  loading?: boolean;
  selected?: boolean;
  children: ReactNode;
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  variant = "submit",
  loading = false,
  selected = false,
  children,
  className = "",
  disabled,
  ...props
}) => {
  const baseStyles =
    "px-4 py-2 rounded-2xl transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 hover:enabled:brightness-125";

  const variantStyles = {
    submit: "border border-secondary text-secondary",
    neutral: "border border-gray-800 text-gray-800",
    primary: "border border-primary text-primary",
  };

  const selectedStyles = {
    submit: selected ? "bg-secondary text-white" : "",
    neutral: selected ? "bg-gray-800 text-white" : "",
    primary: selected ? "bg-primary text-white" : "",
  };

  const loadingStyles = loading ? "opacity-70 cursor-wait" : "";
  return (
    <button
      id={`toggle-button-${variant}`}
      className={`${baseStyles} ${variantStyles[variant]} ${loadingStyles} ${selectedStyles[variant]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <Spinner size="sm" />}
      {children}
    </button>
  );
};

export { ToggleButton };
